import axios from "axios";
import config from "../../config";

const BASE_API = config.BASE_API;
const ENDERECO_API = config.ENDERECO_API;

const criarDependenteVazio = (pessoaTitular) => ({
  id: null,
  versaoObjt: null,
  pessoaTitular: pessoaTitular,
  tipoDependencia: null,
  grauParentesco: null,
  periodicidadeBenef: null,
  dataInicio: null,
  dataFimPrevista: null,
  dataFim: null,
  motivoInicioDependencia: null,
  motivoFimDependencia: null,
  pessoa: {
    id: null,
    cpf: "",
    nome: "",
    sexo: null,
    cor: null,
    mae: "",
    pai: "",
    estadoCivil: null,
    grauDeInstrucao: null,
    tipoCapacidade: null,
    identidade: "",
    orgaoExpedidorIdentidade: "",
    certidaoNasc: "",
    certidaoCas: "",
    livroCertidaoCas: "",
    folhaCertidaoCas: "",
    livroCertidaoNasc: "",
    folhaCertidaoNasc: "",
    tituloEleitor: "",
    zonaTitEleitor: "",
    secaoTitEleitor: "",
    ufTitEleitor: null,
    carteiraHabilit: "",
    localEmissaoHabilit: "",
    tipoSanguineo: null,
    fatorRH: null,
    conselhoProfissional: null,
    carteiraProfissional: "",
    passaporte: "",
    expedicaoPassaporte: null,
    validadePassaporte: null,
    expedicaoCarteiraProfissional: null,
    validadeCarteiraProfissional: null,
    expedicaoIdentidade: null,
    dataDeNascimento: null,
    validadeHabilit: null,
    emissaoHabilit: null,
    municipio: null,
  },
});

const obterListaDependente = (cpf) => {
  return axios.get(BASE_API + "dependencia/lista-dependente/" + cpf);
};

const searchDependente = (id) => {
  return axios.get(BASE_API + "dependencia/dependente/" + id);
};

const listaTipoDependencia = () => {
  return axios.get(BASE_API + "util/tipo-dependencia");
};

const listarGrauParentesco = () => {
  return axios.get(BASE_API + "util/grau-parentesco");
};

const listarMotivoFimDependencia = () => {
  return axios.get(BASE_API + "util/motivo-fim-dependencia");
};

const listarMotivoInicioDependencia = () => {
  return axios.get(BASE_API + "util/motivo-inicio-dependencia");
};

const persistirDependente = (dependente) => {
  return axios.post(`${BASE_API}dependencia/cadastrar/dependente`, dependente);
};

const obterCPF = (cpf) => {
  return axios.get(`${BASE_API}dependencia/pessoa/${cpf}`);
};

const normalizarEnderecoDependente = (endereco) => {
  if (!endereco) return endereco;

  const novo = { ...endereco };

  // se vier: endereco.bairro = { id, nome }
  if (novo?.bairro?.nome) {
    novo.bairro = novo.bairro.nome;
  }

  return novo;
};

const normalizarContatoDependente = (contato) => {
  if (!contato) return contato;
  return { ...contato };
};

const salvarCarteiraTrabalho = (params) => {
  return axios.post(
    BASE_API + "util/carteira-trabalho",
    params
  );
};

const excluirCarteiraTrabalho = (id) => {
  return axios.delete(
    BASE_API + `util/carteira-trabalho/${id}`
  );
};

export default {
  obterListaDependente,
  searchDependente,
  listaTipoDependencia,
  listarGrauParentesco,
  listarMotivoFimDependencia,
  listarMotivoInicioDependencia,
  criarDependenteVazio,
  persistirDependente,
  normalizarContatoDependente,
  normalizarEnderecoDependente,
  obterCPF,
  salvarCarteiraTrabalho,
  excluirCarteiraTrabalho
};
